var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[(_vm.facility=='app')?_c('div',{staticClass:"app"},[_c('App')],1):_c('div',[_c('Pc')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }